<mbs-table-grid [data]="licenses || []"
                [entityName]="'shared:licenses.title' | i18next: { format: 'title' }"
                [headers]="headers"
                [loading]="loading"
                [maxHeight]="tableMaxHeight"
                [minHeight]="'50px'">
  <ng-template let-license
               mbsTableCell>
    {{ license.licenseType.displayName }}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ license.unitPrice | pricePrepayment | async}}
  </ng-template>

  <ng-template *ngIf="isProratedColumnShown"
               let-license
               mbsTableCell>
    {{ license?.unitProratedPrice ? (license.unitProratedPrice | pricePrepayment | async) : 'Not applicable' }}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ (license.discount | number : '1.2-2') + '%' }}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ license.unitTotalPrice | pricePrepayment: (period && license?.licenseType?.id === LicenseType.PremiumSupport ? 'month' : period) | async }}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ license.quantity }}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ license.lineItemPrice | pricePrepayment | async}}
  </ng-template>

</mbs-table-grid>
